/**
 * SpanName Generators are a way to ensure that the span names are unique and consistent across the application.
 */
export const spanNameGenerators = {
  websocketSpan: () => `WebsocketMessage`,
  callPopDesktopSpan: (action: string) => `CallPopNotification-deskphone-${action}`,
  callPopSoftphoneSpan: (action: string) => `CallPopNotification-softphone-${action}`,
};
